import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { DxChartComponent, DxPivotGridComponent } from "devextreme-angular";
import { DxiSeriesComponent } from "devextreme-angular/ui/nested";
import { exportWidgets } from 'devextreme/viz/export';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

@Component({
    selector: 'O2PortalAwardsByRegion',
    templateUrl: './o2-portal-awards-by-region.component.html',
    styleUrls: ['./o2-portal-awards-by-region.component.scss']
})

export class O2PortalAwardsByRegionComponent implements AfterViewInit {

    isLoadPanelVisible: boolean = false;
    o2PortalAwardsByRegionData: any;
    o2PortalAwardsByRegionBarChartData: any;
    o2PortalAwardsByRegionPieChartData: any;

    pivotGridApplicationRegionDataSource: any;
    pivotGridProcessRegionDataSource: any;
    pivotGridCompetitorRegionDataSource: any;
    resolveOverlappingTypes = ['shift', 'hide', 'none'];
    colors: Map<string, string>;

    @ViewChild(DxChartComponent, { static: false }) dxChart: DxChartComponent;
    @ViewChild(DxiSeriesComponent, { static: false }) dxPieChart: DxChartComponent;
    @ViewChild('VolumeAnalysisByCompetitorAndRegion', { static: false }) competitorRegionGrid: DxPivotGridComponent;
    @ViewChild('VolumeAnalysisByApplicationAndRegion', { static: false }) applicationRegionGrid: DxPivotGridComponent;
    @ViewChild('VolumeAnalysisByProcessAndRegion', { static: false }) processRegionGrid: DxPivotGridComponent;
    constructor() {
        this.customizeLabel = this.customizeLabel.bind(this);
        this.colors = new Map<string, string>();
    }

    ngAfterViewInit() {
        this.dxChart.instance.render();
    }

    export() {
        const chartInstance = this.dxChart.instance;
        const pieChartInstance = this.dxPieChart.instance;

        exportWidgets([[pieChartInstance, chartInstance]], {
            fileName: 'ASUAwardsByRegion',
            format: 'PNG',
        });
    }

    exportExcel(e) {
        const context = this;
        const workbook = new Workbook();
        const regwb = workbook.addWorksheet('Competitor And Region');
        const appwb = workbook.addWorksheet('Application And Region');
        const processwb = workbook.addWorksheet('Process And Region');

        exportPivotGrid({
            worksheet: regwb,
            component: context.competitorRegionGrid.instance,

        }).then(() => {
            exportPivotGrid({
                worksheet: appwb,
                component: context.applicationRegionGrid.instance,
            }).then(() => {
                exportPivotGrid({
                    worksheet: processwb,
                    component: context.processRegionGrid.instance,
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer) => {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASU_Awards_By_Region.xlsx');
                    });
                });
            })
        });
    }

    getO2PortalAwardsByRegion(o2PortalAwardsData) {
        this.o2PortalAwardsByRegionData = o2PortalAwardsData;
        this.isLoadPanelVisible = false;
        this.colors.clear();
        this.setDataSources();
    }

    setDataSources() {
        this.pivotGridApplicationRegionDataSource = {
            fields: [{
                caption: 'LASURegions',
                width: 120,
                dataField: 'lasuregions',
                area: 'row',
            }, {
                dataField: 'application',
                area: 'column',
            }, {
                groupName: 'application',
                visible: false,
            }, {
                caption: 'Total',
                dataField: 'totalOxygen',
                dataType: 'number',
                summaryType: 'sum',
                area: 'data',
                format: {
                    precision: Number
                }
            }],
            store: this.o2PortalAwardsByRegionData,
        };

        this.pivotGridProcessRegionDataSource = {
            fields: [{
                caption: 'LASURegions',
                width: 120,
                dataField: 'lasuregions',
                area: 'row',
            }, {
                dataField: 'process',
                area: 'column',
            }, {
                groupName: 'process',
                visible: false,
            }, {
                caption: 'Total',
                dataField: 'totalOxygen',
                dataType: 'number',
                summaryType: 'sum',
                area: 'data',
                format: {
                    precision: Number
                }
            }],
            store: this.o2PortalAwardsByRegionData,
        };

        this.pivotGridCompetitorRegionDataSource = {
            fields: [{
                caption: 'LASURegions',
                width: 120,
                dataField: 'lasuregions',
                area: 'row',
            }, {
                dataField: 'topCompetitors',
                area: 'column',
            }, {
                groupName: 'topCompetitors',
                visible: false,
            }, {
                caption: 'Total',
                dataField: 'totalOxygen',
                dataType: 'number',
                summaryType: 'sum',
                area: 'data',
                format: {
                    precision: Number
                }
            }],
            store: this.o2PortalAwardsByRegionData,
        };

        this.o2PortalAwardsByRegionData.sort((a, b) => a.awardYear - b.awardYear);

        this.o2PortalAwardsByRegionBarChartData = [... this.o2PortalAwardsByRegionData].map(item => ({ ...item }));
        this.o2PortalAwardsByRegionBarChartData = this.o2PortalAwardsByRegionBarChartData.reduce((accm, item) => {

            let accItem = accm.find(ai => ai.awardYear === item.awardYear && ai.lasuregions === item.lasuregions)

            if (accItem) {
                accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen)
               // To remove comma from long datatype field = converted to string
                accItem.awardYear = accItem.awardYear.toString()
            } else {
                item.awardYear = item.awardYear.toString()
                accm.push(item)
            }

            return accm;
        }, []);


        this.o2PortalAwardsByRegionData.sort((a, b) => a.lasuregions - b.lasuregions);
        let allRegionsArrayData = [... this.o2PortalAwardsByRegionData].map(item => ({ ...item }));
        allRegionsArrayData = allRegionsArrayData.reduce((acc, item) => {

            let accItem = acc.find(ai => ai.lasuregions === item.lasuregions)

            if (accItem) {
                accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen)
            } else {
                acc.push(item)
            }

            return acc;
        }, []);

        let totalCountArray = [...allRegionsArrayData].map(item => ({ ...item }));
        const total = totalCountArray.reduce((prevValue, item) => Math.round(prevValue + item.totalOxygen), 0);

        this.o2PortalAwardsByRegionPieChartData = allRegionsArrayData.map((item, index) => {
            let cumulativeCount = item.totalOxygen;
            return {
                lasuregions: item.lasuregions,
                cumulativePercent: Math.round(cumulativeCount * 100 / total),
            };
        });
    }

    customizeLabel(arg) {
        if (!this.colors.has(arg.argumentText)) {
            this.colors.set(arg.argumentText, arg.point.getColor());
        }
        return `${arg.argumentText} (${arg.percentText})`;
    }

    customizeTooltip(arg: any) {
        
        return {
            text: `${arg.seriesName} : ${arg.valueText}` + ' mtpd',
        };
    }

    onCellPrepared(e) {
        if (e.area === "data" && e.cell.text === "") {
            e.cellElement.textContent = "0";
        }
    }

    customizePoint = (arg: any) => {
        if (this.colors.has(arg.data.lasuregions)) {
            return { color: this.colors.get(arg.data.lasuregions), hoverStyle: { color: this.colors.get(arg.data.lasuregions) } };
        }
    }

}